
import { User } from "@/models/user";
import { useNavigate } from "react-router-dom";
import { toast } from "@/components/ui/use-toast";
import { logger } from "@/utils/logger";

/**
 * Checks if user is authenticated and shows appropriate messaging
 */
export const requireAuth = (user: User | null, agentId: string, navigate: ReturnType<typeof useNavigate>) => {
  if (!user) {
    logger.info("Authentication required for action", { agentId });
    toast({
      title: "Authentication required",
      description: "Please log in to continue",
      variant: "destructive"
    });
    navigate("/login");
    return false;
  }
  return true;
};
